// @flow
import { array, bool, mixed, number, object, string } from 'yup';
import {
  GLOBAL_DISCOUNT_BACKEND_NAME,
  IS_ROW_FROZEN,
  METRICS_LEVEL_DISCOUNTS_CONFIG_ARRAY_BACKEND_NAME,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_ARRAY_BACKEND_NAME,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_DIMENSION_VALUES_BACKEND_NAME,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_DISCOUNT_BACKEND_NAME,
  METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_METRIC_NAME_BACKEND_NAME,
} from '@src/constants';
import { spGlobalDiscountValidation } from '@src/configuration/estimate-commit-details';
import { allDimensionsFilledTest, conflictsTest } from '@src/configuration/custom-discounts';

export const spCustomDiscountsValidation = object({
  [GLOBAL_DISCOUNT_BACKEND_NAME]: spGlobalDiscountValidation.notRequired(),
  [METRICS_LEVEL_DISCOUNTS_CONFIG_ARRAY_BACKEND_NAME]: array(
    object({
      [METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_METRIC_NAME_BACKEND_NAME]: string()
        .required()
        .label('Metric Name')
        .nullable()
        .typeError('Please select a metric!')
        .test(
          'notAllDimensionConfigItemsFrozen',
          'Please ensure all Dimension Config Items are frozen except possibly the last one',
          function () {
            return this.parent[METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_ARRAY_BACKEND_NAME].slice(
              0,
              -1
            ).every((dimensionConfigItem) => dimensionConfigItem[IS_ROW_FROZEN] === true);
          }
        ),
      [METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_ARRAY_BACKEND_NAME]: array(
        object({
          [METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_METRIC_NAME_BACKEND_NAME]: string().required(),
          [IS_ROW_FROZEN]: bool().required(),
          [METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_DIMENSION_VALUES_BACKEND_NAME]: array().of(
            mixed().test(
              'string-or-non-empty-array',
              'Must be a non-empty string or non-empty array',
              (value) => {
                if (typeof value === 'string') {
                  return value.length > 0; // non-empty string
                }
                if (Array.isArray(value)) {
                  return value.length > 0; // non-empty array
                }
                return false; // neither string nor array
              }
            )
          ),
          [METRICS_LEVEL_DISCOUNTS_DIMENSIONS_CONFIG_DISCOUNT_BACKEND_NAME]: number()
            .nullable()
            .typeError('Discount is a required field!')
            .label('Discount')
            .min(0)
            .max(100)
            .required()
            .test('allDimensionsFilled', 'Please fill all dimensions', allDimensionsFilledTest)
            .test('conflictsExist', 'Please ensure there are NO conflicts', conflictsTest),
        })
      ).min(1),
    })
  )
    .notRequired()
    .default([]),
});
